const maxEmailLength = 254;
const maxPreAmpLength = 64;
const maxHostNameLength = 255;
const maxPartialHostNameLength = 63;

export default (email) => {
    if (email.indexOf('@') === -1) {
        return 'Must contain an @ sign';
    }

    if (email.split('@')[0].length === 0) {
        return 'Must contain something before the @ symbol';
    }

    if (email.length > maxEmailLength) {
        return `Must have a maximum of ${maxEmailLength} characters`;
    }

    if ((/(?:(?:^\..+?)|(?:\.\..+?)|(?:\.))@/).test(email)) {
        return 'Before the @ sign, dots must not be paired or on the edges';
    }

    const localPartMatches = email.match(/^((?:[\w',\-+]+?\.)+?[\w',\-+]+?|[\w',\-+]+?)@/);

    if (localPartMatches === null || localPartMatches.length !== 2) {
        return 'Only valid characters can precede the @ sign';
    }

    if (localPartMatches[1].length > maxPreAmpLength) {
        return `A maxmimum of ${maxPreAmpLength} characters can precede the @ sign`;
    }

    const hostnamePart = email.substr(localPartMatches[0].length);

    if (hostnamePart.length === 0) {
        return 'Must contain characters after the @ sign';
    }

    if (hostnamePart.length > maxHostNameLength) {
        return `A maximum of ${maxHostNameLength} characters can follow the @ sign`;
    }

    if (!(/^[\dA-Za-z\-.]+?$/).test(hostnamePart)) {
        return 'Invalid characters found after the @ sign';
    }

    if ((/(?:^\.)|(?:\.\.)|(?:\.$)/).test(hostnamePart)) {
        return 'After the @ sign, dots must not be paired or on the edges';
    }

    const hostnameSections = hostnamePart.split('.');
    const hostnameSectionCount = hostnameSections.length;

    for (let h = 0; h < hostnameSectionCount; h += 1) {
        if (hostnameSections[h].length > maxPartialHostNameLength) {
            return `After the @ sign, each dot-separated section can have a maximum of ${maxPartialHostNameLength} characters`;
        }

        if ((/(?:^-)|(?:-$)/).test(hostnameSections[h])) {
            return `After the @ sign, each dot-separated section cannot have dashes on the edges`;
        }
    }

    return '';

};